/**
 * Asset file kind type
 */
export type AssetFileKind =
  | 'image'
  | 'video'
  | 'audio'
  | 'vector'
  | 'presentation'
  | 'document'
  | 'pdf'
  | 'rive'
  | 'compressed'
  | 'spreadsheet'
  | 'threeD'
  | 'other';

/**
 * All valid asset file kind values
 */
export const ASSET_FILE_KINDS: AssetFileKind[] = [
  'image',
  'video',
  'audio',
  'vector',
  'presentation',
  'document',
  'pdf',
  'rive',
  'compressed',
  'spreadsheet',
  'threeD',
  'other',
];

/**
 * Default file extensions by category
 */
export const DEFAULT_IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'] as const;

export const DEFAULT_VIDEO_EXTENSIONS = ['mp4', 'mov', 'webm'] as const;

export const DEFAULT_AUDIO_EXTENSIONS = ['mp3', 'wav'] as const;

export const DEFAULT_DOCUMENT_EXTENSIONS = ['pdf'] as const;

export const DEFAULT_FILE_EXTENSIONS = [
  ...DEFAULT_IMAGE_EXTENSIONS,
  ...DEFAULT_VIDEO_EXTENSIONS,
  ...DEFAULT_AUDIO_EXTENSIONS,
  ...DEFAULT_DOCUMENT_EXTENSIONS,
] as const;
